export default __webpack_public_path__ + "ff07083c1a89dbf21ddbc4d6b8ff4802.webp";